<ng-container #formDirective="parent-form" thr-parent-form>
    <div class="row">
        <div class="col-12">
            <h3 class="mat-subheading-1 text-blue font-weight-bold">
                {{ 'full-data.people-managers' | translate }}
            </h3>

            <table class="table participants mb-4" *ngIf="client.managers.length > 0">
                <thead>
                    <tr>
                        <th></th>
                        <th>{{ 'form.name-administrator' | translate }}</th>
                        <th class="d-none d-md-table-cell">
                            {{ 'form.identification' | translate }}
                        </th>
                        <th class="d-none d-md-table-cell">
                            {{ 'form.citizenship' | translate }}
                        </th>
                        <th width="90px"></th>
                    </tr>
                </thead>
                <tbody>
                    <ng-template ngFor let-manager [ngForOf]="client.managers">
                        <tr>
                            <td [ngSwitch]="manager.nature">
                                <i class="icon-legal" *ngSwitchCase="Nature.COMPANY"></i>
                                <i class="icon-natural-plus" *ngSwitchDefault></i>
                            </td>
                            <td>
                                <strong>{{ manager.fullName }}</strong>
                            </td>
                            <td class="d-none d-md-table-cell">
                                <strong>{{ manager.docId }}</strong>
                            </td>
                            <td class="d-none d-md-table-cell">
                                <ng-template ngFor let-country [ngForOf]="countries">
                                    <strong *ngIf="country.id.value === manager.citizenship">{{ country.name }}</strong>
                                </ng-template>
                            </td>
                            <td class="text-right">
                                <button type="button" class="mat-elevation-z0" mat-icon-button (click)="onEdit(manager)" *ngIf="!isDisabled">
                                    <i class="icon-edit"></i>
                                </button>
                                <button type="button" class="mat-elevation-z0" mat-icon-button (click)="onRemove(manager)" *ngIf="!isDisabled">
                                    <i class="icon-delete"></i>
                                </button>
                            </td>
                        </tr>

                        <tr *ngIf="manager.isLegalPerson">
                            <td>
                                <i class="icon-natural-plus ml-2"></i>
                            </td>
                            <td>
                                <strong>{{ manager.legalName + ' ' + manager.legalSurname }}</strong>
                            </td>
                            <td class="d-none d-md-table-cell">
                                <strong>{{ manager.legalDocId }}</strong>
                            </td>
                            <td class="d-none d-md-table-cell">
                                <ng-template ngFor let-country [ngForOf]="countries">
                                    <strong *ngIf="country.id.value === manager.legalCitizenship">{{ country.name }}</strong>
                                </ng-template>
                            </td>
                            <td class="text-right"></td>
                        </tr>
                    </ng-template>
                </tbody>
            </table>

            <thr-full-data-form-manager [manager]="currentManager" [isDisabled]="isDisabled" *ngIf="adding || editing"></thr-full-data-form-manager>

            <div class="row justify-content-between" *ngIf="!isDisabled">
                <ng-container *ngIf="!adding && !editing">
                    <div class="col-12 col-sm-7 col-md-5 col-lg-4">
                        <button type="button" class="full-width mat-elevation-z0" mat-raised-button color="gray" (click)="onAdd()">
                            {{ 'form.add-other-administrator' | translate }}
                        </button>
                    </div>
                    <div class="col-12 col-sm-5 col-lg-4 mt-3 mt-sm-0">
                        <button type="submit" class="full-width mat-elevation-z0" mat-raised-button color="blue" [disabled]="client.managers.length === 0">
                            {{ 'general.save' | translate }}
                        </button>
                    </div>
                </ng-container>
                <ng-container *ngIf="adding || editing">
                    <div class="col-12 col-sm-6 col-md-5 col-lg-4">
                        <button type="button" class="full-width mat-elevation-z0" mat-raised-button color="gray" (click)="onCancel()" *ngIf="client.managers.length > 0">
                            {{ 'general.cancel' | translate }}
                        </button>
                    </div>
                    <div class="col-12 col-sm-6 col-md-5 col-lg-4 mt-3 mt-sm-0">
                        <button type="button" class="full-width mat-elevation-z0" mat-raised-button color="blue" [disabled]="!isFormValid" (click)="onSave()">
                            {{ 'form.add-administrator' | translate }}
                        </button>
                    </div>
                </ng-container>
            </div>
        </div>
    </div>
</ng-container>
